import { ReactNode } from 'react';
import { Box, Text } from '@nimbus-ds/components';

interface FormFieldProps {
  label: string;
  children: ReactNode;
}

export function FormField({ label, children }: Readonly<FormFieldProps>) {
  return (
    <Box display="flex" flexDirection="column" gap="1">
      <Text fontSize="caption" color="neutral-textLow">
        {label}
      </Text>
      {children}
    </Box>
  );
}
